import { useQuery } from "@tanstack/react-query";
import { cacheOptions, fetchFirebaseData, toList } from "../../../../connector/functions";

const useFirebaseAboutHooks = (l: string) => {
    const about = useQuery({
        queryKey: ['about', l],
        queryFn: () => fetchFirebaseData(`site/${l}/about`),
        ...cacheOptions,
    });

    const experience = useQuery({
        queryKey: ['experience', l],
        queryFn: () => fetchFirebaseData(`site/${l}/experience`),
        ...cacheOptions,
    });

    return {
        title: { ...about, data: about.data?.title },
        titleHighlight: { ...about, data: about.data?.titleHighlight },
        subTitletext: {...about, data: about.data?.subtitle},
        statsData: { ...about, data: toList(about.data?.stats) },
        storyTitle: { ...about, data: about.data?.storyTitle },
        storyText1: { ...about, data: about.data?.storyText1 },
        storyText2: { ...about, data: about.data?.storyText2 },
        experienceData: { ...experience, data: toList(experience.data)?.reverse() },
    };
}

export default useFirebaseAboutHooks;